import { library, findIconDefinition } from "@insidebeehive/fortawesome/fontawesome-svg-core";
// TODO: pnpm i -w [the following libs]
// import { fab } from "@insidebeehive/fortawesome/free-brands-svg-icons";
// import { fad } from "@insidebeehive/fortawesome/pro-duotone-svg-icons";
// import { fal } from "@insidebeehive/fortawesome/pro-light-svg-icons";
// import { far } from "@insidebeehive/fortawesome/pro-regular-svg-icons";
// import { fas } from "@insidebeehive/fortawesome/pro-solid-svg-icons";
// import { fat } from "@insidebeehive/fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import type { IconName, IconPrefix, IconStyle } from "@insidebeehive/fortawesome/fontawesome-svg-core";

import { cn } from "~/lib/utils";

// library.add(fas, fal, fab, fad, far, fat);

export type IconType = `${IconName}-${IconStyle}`;

interface Props extends FontAwesomeIconProps {
  className?: string;
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

// const getIconsList = (prefix: string, iconName: string) => {
//   switch (prefix) {
//     case "fas":
//       return Fas;
//     case "fal":
//       return Fal;
//     case "fad":
//       return Fad;
//     case "fab":
//       return Fab;
//     case "fat":
//       return Fat;
//     default:
//       console.log(Far.faDashboard, "1111");

//       return Far;
//   }
// };
// const findIconByPrefixAndIconName = (prefix: string, iconName: string) => {
//   // const CustomIcon: any = getIconsList(prefix, iconName);
//   for (const key in CustomIcon) {
//     if (CustomIcon[key].prefix === prefix && CustomIcon[key].iconName === iconName) {
//       return CustomIcon[key];
//     }
//   }

//   return null; // Return null if no match is found
// };

// const FontAwesome = ({ name, className, ...props }: Props) => {
//   const perfixList: { name: IconStyle; value: IconPrefix }[] = [
//     { name: "solid", value: "fas" },
//     { name: "regular", value: "far" },
//     { name: "light", value: "fal" },
//     { name: "duotone", value: "fad" },
//     { name: "brands", value: "fab" },
//     { name: "thin", value: "fat" },
//   ];

//   console.log(name, "name");
//   const lastHyphenIndex = name.lastIndexOf("-");
//   const icon = name.substring(0, lastHyphenIndex) as IconName;
//   const style = name.substring(lastHyphenIndex + 1) as IconStyle;
//   const iconPrefix: IconPrefix | undefined = perfixList.find((obj) => obj.name === style)?.value || "fas";
//   // const findIcon = findIconDefinition({ iconName: icon, prefix: iconPrefix });
//   const findIcon = findIconByPrefixAndIconName(iconPrefix, icon);
//   console.log(findIcon, "findIcon");

//   return findIcon ? <FontAwesomeIcon icon={findIcon} className={cn("w-4 h-4", className)} fontFamily="sharp" {...props} /> : null;
// };
const FontAwesome = ({ className, ...props }: Props) => <FontAwesomeIcon className={cn("w-4 h-4", className)} fontFamily="sharp" {...props} />;

export default FontAwesome;
